// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Enums
import {
  countryCodes,
} from 'common.enums';

// Global Components
import * as React from 'react';

// Helpers
import {
  getRegattaEntryParams,
} from 'common.helpers/dist/common';

// Types
type $Props = $Translate & {
  item: $Model<'RegattaEntry'> & {
    RegattaEntryCrewmembers: Array<$Model<'RegattaEntryCrewmember'>>;
  };
  regatta: $Model<'Regatta'>;
};

function RegistrationNoView({
  item,
  regatta,
  t,
}: $Props) {
  const {
    bowNoRegNoString,
    countryAlpha3,
    regNo,
    sailNo,
  } = getRegattaEntryParams({
    bowNoEnabled: regatta.BowNoEnabled,
    countryEnabled: regatta.CountryEnabled,
    regattaEntry: item,
  });

  return (
    <div className={'text-base'}>
      {regatta.CountryEnabled === true ? (
        <>
          <div className={'flex flex-row items-center'}>
            <img
              alt={regNo}
              className={'max-h-6 mr-1'}
              src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCodes[countryAlpha3] || ''}.svg`}
            />
            <span>{countryAlpha3}</span>
          </div>
          {bowNoRegNoString !== countryAlpha3 && (
            <small className={'text-gray-600'}>
              {bowNoRegNoString}
            </small>
          )}
        </>
      ) : (
        <>
          <div title={t('Reg. no.')}>
            {regNo}
          </div>
          {sailNo !== null && (
            <small className={'text-gray-600'}>
              {sailNo}
            </small>
          )}
        </>
      )}
    </div>
  );
}

export default RegistrationNoView;
